import { XApiActionType } from '@ui/utils/ActivityManager/Action';

export const APP_SESSION_EVENTS = ['INITIAL_ROUTE', 'ROUTE_CHANGE'];

export const LRS_X_API_EVENTS: XApiActionType[] = [
  'PLAYED_MEDIA',
  'SUBMITTED_ASSESSMENT',
  'GAVE_ASSIGNMENT',
  'FINISHED_ASSIGNMENT',
  'VIEWED_IMAGE',
  'READ_DOCUMENT',
  'DID_PRACTICE',
  'LEARNED_ETC_CONTENT',
  'ASKED_QUESTION',
  'PARTICIPATED_SOCIAL_LEARNING',
  'REORGANIZED_CLASS',
];
